import React from "react";

const Footer = () => {
  return (
    <footer
      className="shadow-lg font-[Poppins] pt-10 pb-6 px-6 md:px-20 overflow-hidden mt-auto"
      style={{
        background: "linear-gradient(to right, #0f172a, #020617)", // same as navbar
      }}
    >
      {/* Overlay for soft highlight */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/5 via-transparent to-white/5 pointer-events-none"></div>

      {/* Footer grid */}
      <div
        className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10 animate-fadeSlideUp"
        style={{ animationDuration: "1s", animationFillMode: "forwards" }}
      >
        {/* Column 1 - About */}
        <div>
          <h2 className="text-xl font-extrabold mb-3 bg-gradient-to-r from-[#FFD60A] to-[#FFB703] bg-clip-text text-transparent leading-snug animate-pulseSlow">
            QUANTUMSOFT INNOVATIONS
          </h2>
          <p className="text-sm semi-bold text-white leading-relaxed max-w-md">
            At <strong className="font-semibold">Quantumsoft</strong>, we believe that logic is the core building block of innovation, technology, and business transformation  powering the future of enterprise success.
          </p>
        </div>

        {/* Empty column */}
        <div></div>

        {/* Column 3 - Contact */}
        <div>
          <h3 className="text-xl font-bold mb-3 bg-gradient-to-r from-[#FFD60A] to-[#FFB703] bg-clip-text text-transparent leading-snug animate-pulseSlow">
            Get In Touch
          </h3>
          <ul className="text-sm text-white space-y-2 max-w-xs">
            <li>
              <strong>WhatsApp:</strong>{" "}
              <a
                href="https://wa.me/919623170422"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-green-400 underline"
              >
                +91 9623170422
              </a>
            </li>
            <li>
              <strong className="text-white">Working Hours:</strong> Monday - Friday 9.00 AM - 6.00 PM
            </li>
            <li>
              <strong className="text-white">Office:</strong>
              <br />
              204/107, Sapphire Chambers,
              <br />
              First Floor, Baner Road, Baner,
              <br />
              Pune 411045, Maharashtra, INDIA
            </li>
          </ul>
        </div>
      </div>

      {/* Copyright */}
      <div className="relative z-10 text-center text-white text-xs mt-6 border-t border-white/10 pt-3">
        © 2025 QUANTUMSOFT INNOVATIONS. All rights reserved.
      </div>

      {/* Animations */}
      <style>{`
        @keyframes fadeSlideUp {
          0% {
            opacity: 0;
            transform: translateY(15px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeSlideUp {
          opacity: 0;
          animation-name: fadeSlideUp;
          animation-timing-function: ease-out;
          animation-fill-mode: forwards;
          animation-duration: 1s;
        }

        @keyframes pulseSlow {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.7; }
        }
        .animate-pulseSlow {
          animation: pulseSlow 3s ease-in-out infinite;
        }
      `}</style>
    </footer>
  );
};

export default Footer;
